module.exports = __webpack_public_path__ + "static/media/copyIcon.1879d151.svg";